import { useEffect, useState } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { IntlProvider, type AbstractIntlMessages } from "use-intl";
import { defaultLocale, isLocale, type Locale } from "@/config/i18n.config";
import { loadMessages } from "@/i18n/loadMessages";

export function I18nProvider() {
  const { locale: localeParam } = useParams<{ locale: string }>();

  if (!isLocale(localeParam)) {
    return <Navigate to={`/${defaultLocale}/login`} replace />;
  }

  const locale: Locale = localeParam;
  return <LocaleMessagesProvider locale={locale} />;
}

function LocaleMessagesProvider({ locale }: { locale: Locale }) {
  const [messages, setMessages] = useState<AbstractIntlMessages | null>(null);

  useEffect(() => {
    let cancelled = false;
    setMessages(null);
    void loadMessages(locale).then((loaded) => {
      if (!cancelled) setMessages(loaded);
    });
    document.documentElement.lang = locale;
    return () => {
      cancelled = true;
    };
  }, [locale]);

  if (!messages) return null;

  return (
    <IntlProvider locale={locale} messages={messages}>
      <Outlet />
    </IntlProvider>
  );
}
